export default ($axios) => ({
  fetch(query) {
    return $axios.get('/email/campaigns', { params: query }).then((response) => response.data);
  },
});
